module.exports = __webpack_public_path__ + "static/media/panoramic_third_party.6adf7f60.svg";